import { __rest, __assign } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useTheme } from '../hooks/useTheme.js';
import { Box } from '../Box/index.js';

var Heading = function (_a) {
    var as = _a.as, component = _a.component, level = _a.level, crop = _a.crop, _b = _a.align, align = _b === void 0 ? "left" : _b, children = _a.children;
    var _c = useTheme(), handleStyleProps = _c.handleStyleProps, textCrop = _c.textCrop;
    var _d = handleStyleProps({ level: level }, {
        themeKey: "heading",
    }), css = _d.css, forwardProps = __rest(_d, ["css"]);
    return (jsx(Box, __assign({ as: as || component || "h".concat(level), sx: __assign(__assign({ textAlign: align }, (crop && textCrop({ lineHeight: Number(css.lineHeight) }))), css) }, forwardProps, { children: children })));
};
Heading.displayName = "Heading";

export { Heading };
//# sourceMappingURL=Heading.js.map
